import React, { createContext, useContext, useState, useCallback } from 'react'

const defaultConfig = {
    // Body
    colorBody: '#ffffff',
    bodymaterialType: 0.5,
    colorCarbon: '#ffffff',
    // Wheels
    Rims: '#680202',
    rimsmaterialType: 0.5,
    Caliper: '#ffc900',
    calipermaterialType: 0.5,
    rimCovers: '#000000',
    Springs: '#fa1100',
    // Interior
    seatMainMaterial: '#887659',
    seatSecondaryMaterial: '#787777',
    roofMaterial: '#5a4b2b',
    wheelMaterial: '#5a4b2b',
    stitchMaterial: '#5a4b2b',
}

const ConfiguratorContext = createContext()

export function ConfiguratorProvider({ children }) {
    const [config, setConfig] = useState(defaultConfig)
    const [activeCategory, setActiveCategory] = useState(null)

    const updateConfig = useCallback((key, value) => {
        setConfig(prev => ({ ...prev, [key]: value }))
    }, [])

    const toggleCategory = useCallback((category) => {
        setActiveCategory(prev => prev === category ? null : category)
    }, [])

    return (
        <ConfiguratorContext.Provider value={{ config, updateConfig, activeCategory, toggleCategory }}>
            {children}
        </ConfiguratorContext.Provider>
    )
}

export function useConfigurator() {
    return useContext(ConfiguratorContext)
}
